<template>
  <vx-card title="Manage Collection Data">
    <div class="vx-row mb-6">
      <div class="vx-col w-1/2">
        <label class="vs-input--label">Collection Plan ID</label>
        <vs-input class="w-full" v-model="code" type="text" readonly />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col w-1/2">
        <label class="vs-input--label">Territory</label>
        <vs-input class="w-full" v-model="territory" type="text" readonly />
      </div>
    </div>

    <div class="vx-row mb-2">
      <div class="vx-col w-1/2">
        <label class="vs-input--label">Collector / Sales</label>
        <vs-input
          class="w-full"
          v-model="collector_sales"
          type="text"
          readonly
        />
      </div>
    </div>

    &nbsp;
    <!-- table collection plan -->
    <div class="vx-row mb-12">
      <div v-bind:class="[windowPayment ? detailShow : '', detailHide]">
        <div class="core vx-col md:w-1/1 w-full mb-base">
          <vs-table
            stripe
            :multiple="showButtonSave"
            row-key="id"
            :value="selected_rows"
            @input="handleSelectRows"
            description
            maxHeight="500px"
            :sst="true"
            :data="table.data"
            :max-items="table.length"
            :total="table.total"
          >
            <template slot="thead">
              <vs-th>Handover</vs-th>
              <vs-th>Customer ID / Name</vs-th>
              <vs-th>Total Payment</vs-th>
              <vs-th>Invoice Code</vs-th>
              <vs-th>Invoice Info</vs-th>
              <vs-th>Due Date</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :data="tr"
                :key="indextr"
                v-for="(tr, indextr) in data"
                :class="{ 'row-checkbox-disabled': tr.outstanding_value == 0 }"
              >
                <vs-td class="whitespace-no-wrap">
                  {{ tr.outstanding_value == 0 ? 'Not Required' : (isSelected(tr) ? 'Yes' : 'No') }}
                </vs-td>
                <vs-td> {{ tr.customer_code }} - {{ tr.customer_name }}</vs-td>
                <vs-td>{{ tr.total_payment | formatNumber }}</vs-td>
                <vs-td>{{ tr.invoice_no }}</vs-td>
                <vs-td>
                  Number: {{ tr.invoice_no }} <br />
                  Date: {{ tr.invoice_date | formatDate }} <br />
                  Outstanding: {{ tr.outstanding_value | formatNumber }} <br />
                  <!-- Margin (Outstanding - Payment):
                  {{ tr.margin_payment_outstanding | formatNumber }} -->
                </vs-td>
                <vs-td>{{ tr.due_date | formatDate }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
      <!-- sidebar payment info -->
      <transition name="detail-fade">
        <div
          v-if="windowPayment"
          v-bind:class="[windowPayment ? detailShow : '', detailHide]"
        >
          <vs-row>
            <vs-col
              style="padding-bottom: 8px"
              vs-offset="8"
              vs-type="flex"
              vs-justify="rigth"
              vs-align="rigth"
              vs-w="4"
            >
              <vs-button
                class="ml-auto"
                size="small"
                v-on:click="handleClose"
                color="grey"
                icon-pack="feather"
                icon="icon-x-square"
                >Close</vs-button
              >
            </vs-col>
            <div class="vx-col w-5/6 my-2">
              <PaymentFormV2
                :data="child"
                v-for="(
                  child, index
                ) in currentOpenPayments.customer_order_payments"
                :key="index"
                :index="index"
                @deletePayment="setDeletePayment"
                @isChangeData="isHasChangeValue = true"
              />
            </div>
          </vs-row>
        </div>
      </transition>
    </div>

    <div class="vx-row gap-2">
      <vs-button
        @click="onClickBtnSave()"
        size="small"
        color="primary"
        icon-pack="feather"
        icon="icon-save"
        v-if="showButtonSave"
      >
        Submit</vs-button
      >

      <vs-button
        @click="handleCloseHead"
        size="small"
        color="danger"
        icon-pack="feather"
        icon="icon-x"
        >Back</vs-button
      >
    </div>
  </vx-card>
</template>

<script>
import moment from "moment";
import PaymentForm from "./payment-form.vue";
import { formatNumber } from "../../../utils/common";
import PaymentFormV2 from "./payment-form-v2.vue";

export default {
  components: {
    PaymentForm,
    PaymentFormV2,
  },
  data() {
    return {
        ID:null,
        detailShow: "core vx-col md:w-1/2 w-full mb-base ",
        detailHide: "core vx-col md:w-1/1 w-full mb-base ",
        windowPayment: false,
        showButtonSave: true,

        // main data
        uuid: null,
        code: null,
        territory: null,
        collector_sales: null,
        data: null,
        table: this.defaultTable(),
        isCashOrNot: [],
        //   modal edit
        modalEdit: {
          index: null,
          activeModalEdit: false,
          giro_check: null,
          transfer_date: null,
        },

        // option bank
        selectedBank: null,
        optionBank: [],
        // option payment method
        optionPaymentMethod: [],
        collectionPlanLineIds: [],
        isHasChangeValue: false,
        currentOpenPayments: {
          billing_order_id: null,
          customer_order_payments: [],
        },

        // handover
        selected_rows: [],
        selected_row_finals:[],
      };
  },
  computed: {},
  watch: {
    // update margin payment when payment value changed from new_payment_value, so outstanding_value - new_payment_value
    "currentOpenPayments.customer_order_payments": {
      handler: function (val) {
        this.table.data = this.table.data.map((item) => {
          if (item.billing_order_uuid == this.currentOpenPayments.billing_order_uuid) {
            item.customer_order_payments = val;
            item.margin_payment_outstanding =
              item.outstanding_value -
              val.reduce(
                // sini
                (acc, curr) => acc + parseFloat(curr.new_payment_value || curr.payment_value),
                0
              );
          }
          return item;
        });
      },
      deep: true,
    },
  },
  methods: {
    resetData(){
        this.detailShow =  "core vx-col md:w-1/2 w-full mb-base "
        this.detailHide =  "core vx-col md:w-1/1 w-full mb-base "
        this.windowPayment =  false
        this.showButtonSave =  true

        // main data
        this.uuid = null
        this.code = null
        this.territory = null
        this.collector_sales = null
        this.data = null
        this.table = this.defaultTable()
        this.isCashOrNot = []
        //   modal edit
        this.modalEdit = {
          index: null,
          activeModalEdit: false,
          giro_check: null,
          transfer_date: null,
        },

        // option bank
        this.selectedBank = null
        this.optionPaymentMethod = []
        this.collectionPlanLineIds = []
        this.isHasChangeValue = false
        this.currentOpenPayments = {
          billing_order_id: null,
          customer_order_payments: [],
        },

        // handover
        this.selected_rows = []
        this.selected_row_finals =[]
    },
    setSelectedRows(){
      this.selected_rows = this.table.data.filter((item) => {
        return this.selected_row_finals.some(obj => obj.collection_plan_line_id === item.collection_plan_line_id);
      });
    },
    isSelected(item) {
      return this.selected_rows.some(obj => obj.collection_plan_line_id === item.collection_plan_line_id)
    },
    handleSelectRows(val) {
      // header "select all" checkbox bypasses the disabled rows, so filter them out here too
      this.selected_rows = val.filter((item) => item.outstanding_value != 0);
    },
    setDeletePayment(index) {
      this.currentOpenPayments.customer_order_payments.splice(index, 1);
    },
    handleClose() {
      this.windowPayment = false;
      // replace data customer order payment from currentOpenPayments to table.data.routes when billing_order_uuid is same
      this.table.data = this.table.data.map((item) => {
        if (
          item.billing_order_uuid == this.currentOpenPayments.billing_order_uuid
        ) {
          item.customer_order_payments =
            this.currentOpenPayments.customer_order_payments;

          // empty currentOpenPayments
          this.currentOpenPayments = {
            billing_order_uuid: null,
            customer_order_payments: [],
          };
        }
        return item;
      });
    },
    // main method
    async onClickBtnSave() {
			let collection_plan_line_ids = this.selected_rows.map(
				(item) => item.collection_plan_line_id
			);
      let requiredRowsCount = this.table.data.filter((item) => item.outstanding_value != 0).length
      let countNotSelected = requiredRowsCount - collection_plan_line_ids.length

			if (countNotSelected > 0) {
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: `Confirm`,
          text: "Are You sure to submit this collection plan? There are " + countNotSelected + " data that not selected",
          accept: () => {
              this.submitHandover(collection_plan_line_ids)
          },
        });
			} else {
        this.submitHandover(collection_plan_line_ids)
      }
    },
    submitHandover(collection_plan_line_ids) {
      let id = this.$route.params.id;
      if (!id) {
        id = this.ID;
      }
      if (!(id>0)) {
        return
      }
      this.$vs.loading();
      this.$http
      .post("api/sfa/v1/collection-plan/multiple-handover", {
        id: id,
        collection_plan_line_ids: collection_plan_line_ids,
      })
      .then((response) => {
        if (response.code == 200) {
          this.$vs.notify({
            title: "Success",
            text: "Collection plan has been handovered successfully",
            color: "success",
            position: "top-right",
          });
          this.showButtonSave = false;
        } else {
          this.$vs.notify({
            title: "Error",
            text: response.message,
            color: "danger",
            position: "top-right",
          });
        }
        this.$vs.loading.close();
      });
    },
    defaultTable() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalpage: 1,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      };
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    async getData() {
      let id = this.$route.params.id;
      if (!id) {
        id = this.ID;
      }
      if (!(id>0)) {
        return
      }

      this.$vs.loading();
      this.resetData();
      let response = await this.$http.get(`/api/sfa/v1/collection-plan/${id}`);

      if (response.code != 200) {
        this.$vs.notify({
          title: "Failed",
          text: response.message,
          color: "danger",
        });

        this.$vs.loading.close();

        return false;
      }

      let data = response.data;
      this.data = data;
      for (let index = 0; index < data.length; index++) {
        this.isCashOrNot.push(false);
      }

      this.uuid = data.uuid;
      this.code = data.code;
      this.territory = `${data.territory_code} - ${data.territory_name}`;
      this.collector_sales = `${data.sales_number} - ${data.sales_name}`;
      // add new key in customer_order_payments
      let newRoutes = data.routes.map((item) => {
        return {
          ...item,
          // add margin payment
          margin_payment_outstanding:
            item.outstanding_value - item.total_payment,
          customer_order_payments: item.customer_order_payments.map((child) => {
            return {
              ...child,
              temp_file: "",
            };
          }),
        };
      });
      this.data.routes = newRoutes;
      this.table.data = JSON.parse(JSON.stringify(newRoutes));

      // set collection plan line id
      this.collectionPlanLineIds = data.routes.map((item) => {
        return item.collection_plan_line_id;
      });

      // set selected row
      this.selected_rows = this.table.data.filter(obj => obj.return_document === true && obj.outstanding_value != 0)

      this.$vs.loading.close();
    },
    handleCloseHead() {
      this.$emit("close");
    },
  },
  async mounted() {
    await this.getData();
  },
  filters: {
    formatNumber,
    formatDate(value) {
      if (value == "") {
        return "-";
      } else {
        return moment(String(value)).format("DD MMM YYYY");
      }
    },
  },
};
</script>

<style>
.proof-of-payment-upload {
  display: none;
  margin-top: 4px;
}
.file-input-label {
  font-size: 12px;
  padding: 10px 15px;
  border: 1px solid black;
  border-radius: 4%;
}
.border-green {
  border: 1px solid green;
}

.core-enter-active {
  transition: all 0.3s ease;
}
.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.core-enter, .core-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.core {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}
.vertical-divider {
  border-left: 1px solid #7367f0;
  min-height: 800px;
  padding: 5px;
}
.row-checkbox-disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>
